import { Bot, Check, Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";

interface AITopMatchesIconProps {
	/** Size classes of the icon, e.g. "h-4 w-4" */
	className?: string;
	/** The agent is searching: the robot pulses */
	working?: boolean;
	/** The search is done: the sparkles turn into a check */
	done?: boolean;
}

/** The AI Top 25 agent: a bot with a small badge. */
export function AITopMatchesIcon({ className = "h-4 w-4", working = false, done = false }: AITopMatchesIconProps) {
	const Badge = done ? Check : Sparkles;
	return (
		<span className={cn("relative inline-flex shrink-0", className)}>
			<Bot className={cn("h-full w-full", working && "animate-pulse")} />
			<Badge className={cn("absolute -right-[30%] -top-[30%] h-[60%] w-[60%]", working && "animate-ping")} strokeWidth={done ? 3 : 2} />
		</span>
	);
}
